const WRITE_ROLES = new Set(["owner", "admin", "member"]);

/**
 * Mirror the server's effective write roles and fail closed while an older
 * cached session is being refreshed. The capability returned by `/auth/me`
 * remains authoritative whenever it is present.
 */
export function sessionCanWrite(user) {
  if (!user) return false;
  if (typeof user.capabilities?.can_write === "boolean") {
    return user.capabilities.can_write;
  }
  const role = String(user.effective_role || user.role || "").trim().toLowerCase();
  return WRITE_ROLES.has(role);
}
